<template>
  <button @click.prevent="selected = true, $emit('buttonClick')" class="button-primary" :class="[selected ? 'button-primary--selected' : null]">
    <template v-if="!selected">
      {{ title }}
    </template>
    <template v-else>
      <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 8.375L6 12.5L14 1.5" stroke="#64DCBE" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </template>
  </button>
</template>

<script>

export default {
  name: 'ButtonAccept',
  data: () => ({
    selected: false
  }),
  components: {
  },
  computed: {
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: { 
      type: String,
      required: true,
      default: null 
    }
  },
  watch: {
    value: {
      handler (value) {
        this.selected = this.value
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    if (this.value) {
      this.selected = this.value
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../scss/global/includes";

.button-primary {
    width: auto;
    background: $primary;
    color: $white;
    height: 47px;
    padding: 10px 15px;
    min-width: 122px;
    @include responsive-text-size('Button--12--BOLD');
    border-radius: 4px;
    @include ease-fast;
    text-align: center;
    display: inline-flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    border: 1px solid transparent;

    &.button-primary--selected {
      border: 1px solid $light-green;
      background: $white;
    }

}
</style>
